module.exports = __webpack_public_path__ + "static/img/logo.c5c5068.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 151
// module chunks = 13